export const EmptyMatchedStateIcon = require('./emptytMatchedIcon.png')
export const EmptySavedStateIcon = require('./emptySavedIcon.png')
export const EmptyRejectedStateIcon = require('./emptyRejectedIcon.png')
export const EmptyStateIcon2 = require('./emptyStateIcon2.png')
export const AvatarIcon = require('./AvatarIcon.png')
